import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import BetrBolt from '@/assets/icons/betr-small-payment';
import { RadioItem } from '@/components/RadioItem';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useModals } from '@/feature/alerts/hooks/use-modals';
import { useSelectedWithdrawalMethodStore } from '@/feature/withdraw/hooks/use-selected-withdrawal-method';
import { WithdrawStackNavigationProp } from '@/navigation/withdraw/types';
import { common } from '@/styles/styles';
import { runAfterInteractions } from '@/utils/runAfterInteractions';

import { styles } from './WithdrawalMethodItem';

export const RedeemToFantasy = () => {
    const navigation = useNavigation<WithdrawStackNavigationProp>();
    const { t } = useTranslation('transactions');
    const { dismissAll } = useModals();
    const isFantasyRedemptionSelected = useSelectedWithdrawalMethodStore(state => state.isFantasyRedemptionSelected);
    const setFantasyRedemptionSelected = useSelectedWithdrawalMethodStore(state => state.setFantasyRedemptionSelected);

    const handlePress = () => {
        if (!isFantasyRedemptionSelected) setFantasyRedemptionSelected(true);
        navigation.navigate('RedeemToFantasyFormScreen');

        runAfterInteractions(dismissAll);
    };

    return (
        <Pressable
            style={[styles.listItem, common.row, common.alignCenter, common.justifySpaceBetween]}
            onPress={handlePress}
        >
            <Row flex={1} alignItems={'center'}>
                <Box
                    width={48}
                    height={36}
                    marginRight="s16"
                    borderWidth={1}
                    borderColor={ds.colorToken.border.strong}
                    borderRadius="r8"
                    alignItems="center"
                    justifyContent="center"
                >
                    <BetrBolt />
                </Box>
                <Box flex={1}>
                    <Text fontSize={15}>{t('redeem_to_fantasy')}</Text>
                    <Box>
                        <Text color="neutral300" fontSize={13} numberOfLines={1}>
                            {t('redeem_to_fantasy_description')}
                        </Text>
                    </Box>
                </Box>
            </Row>
            <RadioItem selected={isFantasyRedemptionSelected} />
        </Pressable>
    );
};
